
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './paginasobretret4au2r.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Ppaginasobretret4au2r = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {





  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id67102744a68f26b67983bf9c" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404m4lim23uvzm3.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iacot" className="">
      
        <LoftyDropdownComponent
          id="iejkse"
          className="gjs-dropdown-menu-container link-navbar "
          childrenShow={
            <>
              <div id="icmp9k" className="gjs-dropdown-menu-trigger ">
<>Servicios</></div>

            </>
          }
          childrenHover={
            <>
              <div id="ifwrr4" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

      <a
        target=""
        className="link-navbar "
        id="ixxmu"
        href="/tret"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <>TRET</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link-navbar "
        id="i2hsg"
        href="/"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <>CFO Externo</>
    </div>
    
      </a>
      </div>

            </>
          }
        />
        
      <a
        target=""
        className="link-navbar "
        id="ibmm3s"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="iol6vk" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
      </div>
      
      <img
        className=""
        id="iok6z3"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkvb1chy.jpg"
        alt="undefined"
      />
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/tret"
        type=""
      >
        <>TRET</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        <>TRET</>
      </div>
      
      <div className="" id="ir8ccl">
        <>Servicios &gt; TRET</>
      </div>
      
      <div id="ibin0r" className="">
      
        <a
          target=""
          className="botonprimary "
          id="i1ezla"
          href="#"
        >
          
    <div id="icfw7s" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="if5pi" className="">
      
      <div className="" id="i803s">
        <>La única herramienta que necesitas para manejar el flujo de caja de tu empresa de forma fácil y profesional</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>- Genera más rentabilidad con la liquidez de tu empresa.</>
      <br className="" id="" />
      <>- Reduce costos financieros innecesarios.</>
      <br className="" id="" />
      <>- Gana velocidad en la toma de decisiones sobre tu liquidez.</>
      <br className="" id="" />
      <>- Alarmas eficientes: Nuevas oportunidades de mercado o posibles escenarios de estrés de tu liquidez</>
      </div>
      
      </div>
      
      </div>
      
      <div id="i6xx" className="">
      
      <div id="i0tfl" className="">
      
      <div id="ivvvb5" className="">
      
      <div id="iyqmu8" className="">
      
      </div>
      
      </div>
      
      <div id="im4sk2" className="">
      
          <div id="i22j24" className="">
            <iframe
              title="Video Youtube"
              src="https://www.youtube.com/embed/Wih8C0cGXfk?"
              allowFullScreen="undefined"
              style={{
                width: '100%',
                height: '100%',
              }}
            />
          </div>
          
      </div>
      
      <div id="it9es4" className="">
      
      <div id="irbv49" className="">
      
          <div id="i0y2lo" className="">
            <iframe
              title="Video Youtube"
              src="https://www.youtube.com/embed/_kFgJqg-sp8?"
              allowFullScreen="undefined"
              style={{
                width: '100%',
                height: '100%',
              }}
            />
          </div>
          
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="isbhos" className="">
      
      <div
        id="iq3f0x"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="i3caqq" className="">
      
      <div id="irc04x" className="">
      
      <div id="i43gtg" className="">
      
      <div id="i39utq" className="">
      
      <div className="subtitulo " id="i6p8b1">
        <>¿Cómo puedo sacar el mejor provecho a la liquidez de mi empresa?</>
      </div>
      
      <div className="descripcion2 " id="i1mwly">
        <>La liquidez de tu empresa puede que no esté generando mucho en este momento. La razón se encuentra comúnmente escondida en tu flujo de caja.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>¡Sí, ese mismo!, el que te dice cuánto tienes hoy, cuánto vas a recaudar y pagar en éste y los próximos meses.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="ibf9kj" className="">
      
      <img
        className=""
        id="i2nnhu"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk12kfjc.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="i57dji" className="">
      
      <div id="itrilx" className="">
      
      <img
        className=""
        id="iyleqi"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkfv1u1c.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="i2hmye" className="">
      
      <div className="subtitulo " id="i1mwnf">
        <>¿PODEMOS AYUDARTE EN LA GESTIÓN FINANCIERA DE TU EMPRESA? </>
      </div>
      
      <div className="descripcion2 " id="ivi9ki">
        <>Tenemos las habilidades de un buen gerente Financiero en el manejo eficiente de los recursos, detectar riesgos financieros y no menos importante, negociar las mejores condiciones bancarias</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ic07ai" className="">
      
      <div id="ildooc" className="">
      
      <div className="subtitulo " id="ijgi5b">
        <>¿Demasiado ocupado para ver todas las oportunidades financieras?</>
      </div>
      
      <div className="descripcion2 " id="ip083n">
        <>Sabemos lo retador que es mantener tu negocio funcionando y queremos ayudarte a reducir la carga.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Por esto, a partir de una poca información financiera, TRET te construye y analiza tu flujo de caja, monitorea los productos financieros disponibles y encuentra las mejores respuestas para que puedas rentabilizar tu liquidez.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="ieu90w" className="">
      
      <img
        className=""
        id="ibg6qj"
        src="https://assetsprojects.s3.amazonaws.com/405opfilklpr4en.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="ipheoy" className="">
      
      <div id="iyr2ub" className="">
      
      <img
        className=""
        id="irm6ox"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkcxaspf.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="ih3fni" className="">
      
      <div className="subtitulo " id="iy8kez">
        <>¿Quieres mantener las cosas simples? </>
      </div>
      
      <div className="descripcion2 " id="i20htm">
        <>Los softwares normalmente requieren horas de tu tiempo y de tu equipo para realizar su instalación y mantenimiento, pero realmente no te dan respuestas claras sobre lo que debes hacer.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>TRET te da las respuestas que estas buscando para tener un manejo óptimo de tu flujo de caja, lo que te permitirá tener más tiempo para las cosas importantes, como enfocarte en tú negocio, tu familia o tus hobbies.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      <p className="" id="iyyhre">
        
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="irqujg" className="">
      
      <div id="iwqp1k" className="">
      
      <div id="i06tr1" className="">
      
      <img
        className=""
        id="iv7kbi"
        src="https://assetsprojects.s3.amazonaws.com/405opfilku9i145.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iyw1nu" className="">
      
      <div id="i2girj" className="">
      
      <div className="" id="i1l31g">
        <>Simula tu inversión en liquidez</>
      </div>
      
      <div className="" id="iwuzzj">
        <>Ganas Más con TRET</>
      </div>
      
      </div>
      
      <div id="i2ngo3" className="">
      
      <div className="" id="i33d6b">
        <>¿Te gustaría saber cómo crecería tu dinero con una estrategia de inversión inteligente?</>
      </div>
      
      <div id="i4mcz4" className="">
      
        <div id="i4s1ml" className="">
          
      <input
        name=""
        type="text"
        placeholder=""
        className=""
        id="i8oek4"
      />
      
        </div>
      
      <button
        type=""
        name=""
        id="ic7yd7"
        className="botonprimary "
        
      >
      
      <div id="iayu2l" className="">
      <>Simular</>
      </div>
      
      </button>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div id="iys268" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/404m4lim0h22y66.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iyo7r6">
        <>Externaliza tu CFO con TRET</>
      </div>
      
      <div className="" id="iygu8i">
        
      <a
        target=""
        className=""
        id="ionor8"
        href="mailto:gerencia@tret.com.co"
        type=""
      >
        <>gerencia@tret.com.co</>
      </a>
      
      </div>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Dirección</>
      </div>
      
      <div className="" id="igdgp1">
        <>Carrera 8 #85-31, Bogotá, Colombia</>
      </div>
      
      <div className="" id="io8u0g">
        
      <a
        target=""
        className=""
        id="ivbmuk"
        href="mailto:gerencia@tret.com.co"
        type=""
      >
        <>gerencia@tret.com.co</>
      </a>
      
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div className="" id="il1rnw">
        
      <a
        target=""
        className=""
        id="ic38zj"
        href="mailto:gerencia@tret.com.co"
        type=""
      >
        <>gerencia@tret.com.co</>
      </a>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Ppaginasobretret4au2r);
  